<template>
  <div class="learning-details">
    <div class="header">
      <div class="title">
        <!-- <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" /> -->
        <h1 >{{ learningDetailsMsg.fileTitle }} </h1>
      </div>
      <div style="margin-bottom:10px"> <a-tag color="green" v-if="learningDetailsMsg.fileType==='1'">成功</a-tag>
        <a-tag color="orange" v-if="learningDetailsMsg.fileType==='2'">经验</a-tag></div>
      <p><span>作者：</span>{{ learningDetailsMsg.courseAuthor }}</p>
      <p ><span>简介：</span>{{ learningDetailsMsg.briefIntroduction }}</p>
    </div>
    <div class="footer">
      <video :src="OSS_BASE_URL + urlDeatil" controls="controls" :poster="OSS_BASE_URL + coverPictureUrl"></video>
    </div>
  </div>
</template>

<script>
import { getLearning } from '@/api/system/learning'
const OSS_BASE_URL = process.env.VUE_APP_OSS_URL
export default {
  data () {
    return {
      OSS_BASE_URL,
      learningDetailsMsg: {},
      urlDeatil: '',
      coverPictureUrl: ''
    }
  },
  created () {
    if (this.$route.query.id) {
      this.getLearningDetails(this.$route.query.id)
    }
  },
  methods: {
    /***
     * 获取详情
     */
    getLearningDetails (id) {
      getLearning(id).then((res) => {
        const { code, data } = res
        if (code === 200) {
          this.learningDetailsMsg = data
          this.urlDeatil = this.learningDetailsMsg.fileUrlList[0].fileName
          this.coverPictureUrl = data.coverPictureVo.fileName
          console.log(data)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.learning-details {
  .header{
    padding: 20px;
    background-color: #fff;
    .title{
      display: flex;
      align-items: center;
      height: 26px;
      line-height: 26px;
      align-content: center;
      i{
        margin-bottom: 6px;
      }
    }
  }
  .footer{
    margin-top: 10px;
    background-color: #fff;
      padding: 20px;
  }
  h1 {
    font-size: 20px;
    font-weight: 700;
    color: #222222;
    cursor: pointer;
  }
  p {
    color: #666666;
    font-size: 14px;
    span {
      color: #222222;
      font-weight: 700;
    }
  }
  video {
    width: 100%;
    // object-fit: cover;
    height: 600px;
  }
  .cover-img{
    width: 80px;
    img{
      width: 80px;
    }
  }
}
</style>
